app.directive('selectSingleStatut', ['$filter', '$timeout', 'SideBarService', function ($filter, $timeout, SideBarService) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        require: '?ngModel',
        scope: {
            'title': '@',
            'default': '=',
            'disable': '=',
            'removeTitle': '@',
            'data': '=',
            'classDropdown': '@',
            'jsonData': '=',
            'attrLabel': '@',
            'test': '=ngModel',
            'change': '&ngChange',
            'searchText': '=?searchText',
            'ngChangeSearchtext': '&',
            'currentobjectid':'=',
            'lang': '=',
            'typeid': '='
        },
        templateUrl: "application/templates/directives/selectSingleStatut.html",
        link: function (scope, element, attrs, ngModel) {
            if (ngModel) {
                scope.$watch('selectedValue', function (newVal, oldVal) {
                    ngModel.$setViewValue(scope.selectedValue);
                });
            }
        },
        controller: function ($scope, $rootScope) {
            $scope.selectedValue = null;
            $scope.hideSpan = $scope.default ? true : false;
            $scope.click = false;
            $scope.default = $scope.default ? $scope.default : null;
            $scope.sub = "";
            var height = 40 * ($scope.data ? $scope.data.length : $scope.jsonData.length);
            $scope.config = {
                setHeight: height
            };
            $scope.changeValue = function (value, event) {
                $scope.default = value;
                $scope.hideSpan = $scope.default ? true : false;
                $scope.sub = "";
            };
            $scope.changeValueSub = function (value, event) {
                $scope.defaultSub = value;
                $scope.click = !$scope.click;
            };
            $scope.changeValueSearch = function () {
                $scope['searchText'] = $scope.inputValue;
                if ($scope['ngChangeSearchtext']) {
                    $scope.ngChangeSearchtext($scope.inputValue);
                }
            };
            $scope.focusSearch = function (event) {
                $(event.currentTarget).closest(".select-single-statut").find("input[type='text']").focus();
            };
            $scope.toggled = function (open) {
                $scope.click = false;
                delete $scope.inputValue;
            }
            $scope.UpdateObjectStatus = function UpdateObjectStatus(status) {              
                SideBarService.UpdateObjectStatus(status, $scope.currentobjectid, $scope.lang, $scope.typeid, $rootScope.CurrentZoneId                );
                                                          
            };
         
        }
    }
}]);